const ConfirmOrder = () =>
  import(
    /* webpackChunkName: 'coffee/wechat-community/exclusive-price/order' */ './order/index'
  );

export default {
  ConfirmOrder,
};
